import React, { useState, useEffect } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useNavigate, Link } from 'react-router-dom';

function RegisterPage() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const { executeRecaptcha } = useGoogleReCaptcha();
    const navigate = useNavigate();
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [phone, setPhone] = useState('');
    const [address, setAddress] = useState('');
    const [postcode, setPostcode] = useState('');
    const [city, setCity] = useState('');
    const [country, setCountry] = useState('Polska');
    const [privacyAccepted, setPrivacyAccepted] = useState(false);
    const [marketingConsent, setMarketingConsent] = useState(false);
    const [allAccepted, setAllAccepted] = useState(false);

    useEffect(() => {
        const allRequired = termsAccepted && privacyAccepted;
        const allIncludingOptional = allRequired && marketingConsent;
        setAllAccepted(allIncludingOptional);
    }, [termsAccepted, privacyAccepted, marketingConsent]);

    const handleSelectAll = (checked) => {
        setAllAccepted(checked);
        setTermsAccepted(checked);
        setPrivacyAccepted(checked);
        setMarketingConsent(checked);
    };

    const handleIndividualChange = () => {
        const allRequired = termsAccepted && privacyAccepted;
        const allIncludingOptional = allRequired && marketingConsent;
        setAllAccepted(allIncludingOptional);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        if (!termsAccepted || !privacyAccepted) {
            setError('Musisz zaakceptować regulamin i politykę prywatności!');
            return;
        }
        if (password !== password2) {
            setError('Hasła nie są takie same!');
            return;
        }
        if (!email || !password || !firstName || !lastName) {
            setError('Uzupełnij wszystkie wymagane pola!');
            return;
        }
        if (!executeRecaptcha) {
            setError('Nie udało się połączyć z reCAPTCHA!');
            return;
        }

        const recaptchaToken = await executeRecaptcha('register');

        try {
            const response = await fetch('/wp-json/wp/v2/users/register', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    username: email,
                    email,
                    password,
                    recaptchaToken,
                    termsAccepted: termsAccepted,
                    privacyAccepted: privacyAccepted,
                    marketingConsent: marketingConsent,
                    firstName: firstName,
                    lastName: lastName,
                    phone: phone,
                    address: address,
                    postcode: postcode,
                    city: city,
                    country: country,
                }),
            });
            const data = await response.json();

            if (data.success) {
                navigate('/login?registration=success');
            } else {
                setError(data.message || 'Wystąpił błąd rejestracji.');
            }
        } catch (err) {
            setError('Błąd połączenia z serwerem.');
        }
    };

    return (
        <div className="auth-page">
        <div style={{ maxWidth: '500px', margin: '0 auto' }}>
        <div className="auth-form-panel">
        <h2 className="auth-form-title">Rejestracja</h2>

        <p className="auth-benefits-subtitle">
        Już zarejestrowany? <Link to="/login" style={{ color: '#F53447', fontWeight: '500' }}>Zaloguj się tutaj</Link>
        </p>

        {/* Komunikaty systemowe */}
        {error && <div className="alert alert-error">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}

        <form onSubmit={handleSubmit}>

        {/* Dane logowania */}
        <div className="auth-form-group">
        <label className="auth-form-label">Adres e-mail <span style={{ color: '#F53447' }}>*</span></label>
        <input type="email" className="auth-form-input" value={email} onChange={e => setEmail(e.target.value)} required />
        </div>

        <div className="auth-form-group">
        <label className="auth-form-label">Hasło <span style={{ color: '#F53447' }}>*</span></label>
        <input type="password" className="auth-form-input" value={password} onChange={e => setPassword(e.target.value)} required />
        </div>

        <div className="auth-form-group">
        <label className="auth-form-label">Powtórz hasło <span style={{ color: '#F53447' }}>*</span></label>
        <input type="password" className="auth-form-input" value={password2} onChange={e => setPassword2(e.target.value)} required />
        </div>

        {/* Dane osobowe */}
        <div className="auth-form-group">
        <label className="auth-form-label">Imię <span style={{ color: '#F53447' }}>*</span></label>
        <input type="text" className="auth-form-input" value={firstName} onChange={e => setFirstName(e.target.value)} required />
        </div>

        <div className="auth-form-group">
        <label className="auth-form-label">Nazwisko <span style={{ color: '#F53447' }}>*</span></label>
        <input type="text" className="auth-form-input" value={lastName} onChange={e => setLastName(e.target.value)} required />
        </div>

        <div className="auth-form-group">
        <label className="auth-form-label">Telefon</label>
        <input type="tel" className="auth-form-input" value={phone} onChange={e => setPhone(e.target.value)} />
        </div>

        {/* Adres (opcjonalny) */}
        <div className="auth-form-group">
        <label className="auth-form-label">Ulica i numer</label>
        <input type="text" className="auth-form-input" value={address} onChange={e => setAddress(e.target.value)} />
        </div>

        <div className="auth-form-group">
        <label className="auth-form-label">Kod pocztowy</label>
        <input type="text" className="auth-form-input" value={postcode} onChange={e => setPostcode(e.target.value)} placeholder="00-000" />
        </div>

        <div className="auth-form-group">
        <label className="auth-form-label">Miasto</label>
        <input type="text" className="auth-form-input" value={city} onChange={e => setCity(e.target.value)} />
        </div>

        <div className="auth-form-group">
        <label className="auth-form-label">Kraj</label>
        <input type="text" className="auth-form-input" value={country} disabled style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }} />
        </div>

        {/* Sekcja zgód */}
        <div className="consent-section">
        {/* Checkbox "Zaznacz wszystkie" */}
        <label className="consent-label consent-label-master">
        <input
        type="checkbox"
        className="consent-checkbox consent-checkbox-master"
        checked={allAccepted}
        onChange={(e) => handleSelectAll(e.target.checked)}
        />
        <span className="consent-text">Zaznacz wszystkie</span>
        </label>

        {/* Regulamin - obowiązkowy */}
        <label className="consent-label consent-label-required">
        <input
        type="checkbox"
        className="consent-checkbox"
        checked={termsAccepted}
        onChange={(e) => setTermsAccepted(e.target.checked)}
        required
        />
        <span className="consent-text">
        <span className="consent-required-star">*</span>
        Akceptuję <a href="/regulamin" target="_blank" className="consent-link">Regulamin</a> (Ogólne Warunki Użytkowania oraz Ogólne Warunki Sprzedaży)
        </span>
        </label>

        {/* Polityka prywatności - obowiązkowa */}
        <label className="consent-label consent-label-required">
        <input
        type="checkbox"
        className="consent-checkbox"
        checked={privacyAccepted}
        onChange={(e) => setPrivacyAccepted(e.target.checked)}
        required
        />
        <span className="consent-text">
        <span className="consent-required-star">*</span>
        Akceptuję <a href="/polityka-prywatnosci" target="_blank" className="consent-link">Politykę Prywatności i Wykorzystania Plików Cookies</a>
        </span>
        </label>

        {/* Zgoda marketingowa - opcjonalna */}
        <label className="consent-label consent-label-optional">
        <input
        type="checkbox"
        className="consent-checkbox"
        checked={marketingConsent}
        onChange={(e) => setMarketingConsent(e.target.checked)}
        />
        <span className="consent-text">
        Wyrażam zgodę na otrzymywanie informacji marketingowych
        </span>
        </label>

        <p className="consent-note">* pola obowiązkowe</p>
        </div>

        <button className="auth-submit-btn" type="submit">
        ZAREJESTRUJ SIĘ
        </button>
        </form>
        </div>
        </div>
        </div>
    );
}

export default RegisterPage;
